import { AnyRecord } from 'types';

const devConfig = {
  MAX_ATTACHMENT_SIZE: 5000000,
  s3: {
    REGION: 'us-east-2',
  },
  apiGateway: {
    REGION: 'us-east-2',
  },
  cognito: {
    REGION: 'us-east-2',
    USER_POOL_ID: 'us-east-2_Sz7QNxqRR',
    APP_CLIENT_ID: '2j0gd5v5hj74s0osu73t20fuaq',
    IDENTITY_POOL_ID: 'us-east-2:4839db0c-d8dc-4c10-9fc7-071fb185fab7',
  },
};

const gammaConfig = {
  MAX_ATTACHMENT_SIZE: 5000000,
  s3: {
    REGION: 'us-east-2',
  },
  apiGateway: {
    REGION: 'us-east-2',
  },
  cognito: {
    REGION: 'us-east-2',
    USER_POOL_ID: 'us-east-2_83YLskWe7',
    APP_CLIENT_ID: '5mq7qm5070h569vbal34opj9lk',
    IDENTITY_POOL_ID: 'us-east-2:d82aa77b-9448-4f92-ab0c-a5ecf33c9a25',
  },
};

const prodConfig = {
  MAX_ATTACHMENT_SIZE: 5000000,
  s3: {
    REGION: 'us-east-2',
  },
  apiGateway: {
    REGION: 'us-east-2',
  },
  cognito: {
    REGION: 'us-east-2',
    USER_POOL_ID: 'us-east-2_JdTuVVxMe',
    APP_CLIENT_ID: '646gh18fconj4s6fa3a639r3hc',
    IDENTITY_POOL_ID: 'us-east-2:2b8ebc24-1afb-43a8-bcb3-6baba85221b9',
  },
};

const omegaConfig = {
  MAX_ATTACHMENT_SIZE: 5000000,
  s3: {
    REGION: 'us-east-2',
  },
  apiGateway: {
    REGION: 'us-east-2',
  },
  cognito: {
    REGION: 'us-east-2',
    USER_POOL_ID: 'us-east-2_0wxmr7nRA',
    APP_CLIENT_ID: '8c8lq9mo3fc3fkda702sr97lh',
    IDENTITY_POOL_ID: 'us-east-2:7a0f318b-563d-420e-b548-ecf318b8f3b1',
  },
};

export const getConfig = (): AnyRecord => {
  const { KODS_APP_ENV } = process.env;

  switch (KODS_APP_ENV) {
    case 'gamma':
      return gammaConfig;
    case 'prod':
      return prodConfig;
    case 'dev':
      return devConfig;
    case 'omega':
      return omegaConfig;
    default:
      return devConfig;
  }
};
